import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

export const useLoadData = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['Clinic'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/clinics.json`)
      if (!res.ok) {
        throw new Error(`Error fetching clinic: ${res.statusText}`)
      }
      return res.json()
    },
  })

  const clinic = data
  const types = clinic?.appointmentTypes || {}
  const rooms = clinic?.rooms || []
  const doctors = clinic?.doctors || []

  return {
    loading: isLoading,
    error: isError,
    clinic,
    rooms,
    doctors,
    types,
  }
}
